import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import hardcodedBranding from "../hardcodedBranding";
import createPersistedState from "vuex-persistedstate";
import config from "../config/constants";
import router from "../router"
Vue.use(Vuex);

const defaultUser = {
  bupa_golden_id: false,
  authenticated: false,
  success: false,
  up_domain: "up",
  insights_completed: false,
  user_client_id: Number,
  user_id: String,
  user_role: "cl",
  user_token: String,
  username: String,
  user_pp_slug: "generic_pp",
  user_tc_slug: "generic_tc",
  v3_ready: true,
  eligibility: null,
  home_page: 'old_default',
  access_code_user: false,
  user: {
    first_name: String,
    last_name: String,
    email: String
  },
  user_profile: {
    image_url: String,
    bio: String,
    dob: String,
    gender: String,
    phone: String,
    education_level: String,
    place_of_birth: String,
    relationship_status: String,
    dependants: Number,
    employment_status: String,
    job_type: String,
    occupation: String,
    address: String,
    city: String,
    county: String,
    postal_code: String,
    disability: Boolean,
    disability_specify: String,
    next_of_the_kin_full_name: String,
    next_of_the_kin_phone: String,
    gp_name: String,
    gp_phone: String,

  },
  user_settings: {
    email_notifications: Boolean,
    push_notifications: Boolean,
    inactive_pushes_sent: Number,

  }
};
const defaultClient = {
  client_logo: "/img/blualogo.svg",
  client_name: "Default Client",
  currency: "eur",
  eap_active: false,
  logo:
    "https://healthcoach-media.com/res/images/esp/customise/spectrum-life-logo.png",
  skin: 29,
  success: true
};
export default new Vuex.Store({
  state: {
    user: defaultUser,
    client: defaultClient,
    warning: null,
    cutOffCounter: 10,
    event: {},
    isIE: true,
    isSaml: false,
    home_page: "old_default",
    nav: [],
    homeRoute: "/",
    subdomain: "app",
    accessCode: 0,
    lang: 'en',
    pageTitle: '',
    previousRoute: null,
    podcastQueue: [],
    podcastQueuePosition: 0,
  },
  getters: {
    //TODO:: use mapState appropriately instead of getters
    user: state => state.user,
    user_id: state => state.user.user_id,
    eligibility: state => state.user.eligibility,
    country: state => state.user.user.country,
    client: state => state.client,
    coach: state => state.user.coach,
    warning: state => state.warning,
    skin: state => state.client.skin,
    event: state => state.event,
    currency: state => state.client.currency,
    isIE: state => state.isIE,
    isSaml: state => state.isSaml,
    nav: state => state.nav,
    homeRoute: state => state.homeRoute,
    subdomain: state => state.subdomain,
    hardcoded: state => {
      if (hardcodedBranding[state.subdomain]) {
        return hardcodedBranding[state.subdomain];
      } else return false;
    },
    podcastQueue: state => state.podcastQueue,
    podcastQueuePosition: state => state.podcastQueuePosition,
  },
  mutations: {
    setUser(state, user) {
      state.user.bupa_golden_id = user.bupa_golden_id,
      state.user.eligibility = user.bupa_eligibility
      state.user.user_token = user.user_token;
      state.user.user_role = user.user_role;
      state.user.username = user.username;
      state.user.v3_ready = user.v3_ready;
      state.user.user_id = user.user_id;
      state.user.user_client_id = user.user_client_id;
      state.user.up_domain = user.up_domain;
      state.user.authenticated = user.authenticated;
      state.user.user = user.user;
      state.user.user_pp_slug = user.pp_slug;
      state.user.user_tc_slug = user.tc_slug;
      state.user.coach = user.coach;
      state.user.home_page = user.home_page;
      state.user.access_code_user = user.access_code_user;
    },
    setUserProfile(state, user_profile) {
      state.user.user_profile.image_url = user_profile.image_url
      state.user.user_profile.bio = user_profile.bio
      state.user.user_profile.gender = user_profile.gender
      state.user.user_profile.phone = user_profile.phone
      state.user.user_profile.dob = user_profile.dob
      state.user.user_profile.education_level = user_profile.education_level
      state.user.user_profile.place_of_birth = user_profile.place_of_birth
      state.user.user_profile.relationship_status = user_profile.relationship_status
      state.user.user_profile.dependants = user_profile.dependants
      state.user.user_profile.employment_status = user_profile.employment_status
      state.user.user_profile.job_type = user_profile.job_type
      state.user.user_profile.occupation = user_profile.occupation
      state.user.user_profile.relationship_status = user_profile.relationship_status
      state.user.user_profile.address = user_profile.address
      state.user.user_profile.city = user_profile.city
      state.user.user_profile.county = user_profile.county
      state.user.user_profile.postal_code = user_profile.postal_code
      state.user.user_profile.disability = user_profile.disability
      state.user.user_profile.disability_specify = user_profile.disability_specify
      state.user.user_profile.next_of_the_kin_full_name = user_profile.next_of_the_kin_full_name
      state.user.user_profile.next_of_the_kin_phone = user_profile.next_of_the_kin_phone
      state.user.user_profile.gp_name = user_profile.gp_name
      state.user.user_profile.gp_phone = user_profile.gp_phone
    },
    setUserSettings(state, user_settings) {
      state.user.user_settings.email_notifications = user_settings.email_notifications
      state.user.user_settings.push_notifications = user_settings.push_notifications
      state.user.user_settings.inactive_pushes_sent = user_settings.inactive_pushes_sent
    },
    setUserInsightsStatus(state, insights_completed) {
      state.user.insights_completed = insights_completed;
    },
    setClientBranding(state, client) {
      state.client.client_name = client.client_name;
      state.client.client_logo = client.client_logo;
      state.client.eap_active = client.eap_active;
      state.client.currency = client.currency;
      //hardcode bupa theme;
      state.client.skin = 29;
      state.client.logo = client.logo;
      state.accessCode = client.access_code;
      state.client.pp_slug = client.pp_slug;
      state.client.tc_slug = client.tc_slug;
    },
    setSkin(state, skin) {
      state.client.skin = skin;
    },
    setBrowserIE(state, isIE) {
      state.isIE = isIE;
    },
    setSamlTrue(state){
      state.isSaml = true;
    },
    setWarning(state, warning) {
      state.warning = warning;
    },
    acceptWarning(state) {
      state.warning = null;
    },
    logout(state) {
      state.user = defaultUser;
      state.isSaml = false;
      //state.client = defaultClient;
    },
    viewEvent(state, event) {
      state.event = event;
    },
    setNav(state, nav) {
      state.nav = nav;
    },
    setHomeRoute(state, home) {
      state.homeRoute = home;
    },
    setDomain(state, domain) {
      state.subdomain = domain;
    },
    setAccessCode(state, hasCode) {
      state.accessCode = hasCode;
    },
    setLanguage(state, language){
      const availableLanguages = ['en', 'de']
      if(availableLanguages.includes(language)) {
        state.lang = language
      }
    },
    setPageTitle(state, title){
      state.pageTitle = title
    },
    setPreviousRoute(state, route){
      state.previousRoute = route
    },
    setPodcastQueue(state, podcastQueue) {
      state.podcastQueue = podcastQueue;
    },
    setPodcastQueuePosition(state, podcastQueuePosition) {
      state.podcastQueuePosition = podcastQueuePosition;
    },
    setUserTermsAgreementTrue(state) {
      state.user.user.tc_accepted = true;
    },
    setUserPPAgreementTrue(state) {
      state.user.user.pp_accepted = true;
    },
    setCoach(state, coach){
      state.user.coach = coach;
    },
    setUserCookiesAgreementTrue(state) {
      state.user.user.cookies_accepted = true;
    },
  },
  actions: {
    setUserProfile(context, payload) {
      context.commit('setUserProfile', payload)
    },
    setUserSettings(context, payload) {
      context.commit('setUserSettings', payload)
    },
    async signIn(context, payload) {
      try {
        let res = await axios.post(
          config.api_env + "/application/api-hc/authenticate",
          payload.payload,
          config.options
        );
        if (res.data.success === true) {
          context.commit("setUser", res.data);
          context.commit("setLanguage", res.data.lang);
          //check if user is on v3 portal - if yes continue - if find their organisation
          if (res.data.v3_ready) {
            //if the subdomain is laya wellbeing don't get the clients branding
            if(context.state.subdomain !== 'laya-wellbeing') {
              context.dispatch("getClientBranding", res.data.user_token);
              context.dispatch("getClientInsights", res.data.user_token);
            }
            const homeroute = await context.dispatch(
              "getNav",
              res.data.user_token
            );
            context.state.previousRoute ? payload.router.push(context.state.previousRoute.path) : homeroute ? payload.router.push(homeroute) : payload.router.push("/")
            return true;
          } else return false;
        } else {
          await context.commit("setWarning", res.data.err);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    async accessCodeLogin(context, payload) {
      //try to get the nav for a user with the access code, if it returns then it's a valid code.
      const homeroute = await context.dispatch("getNav", payload.accessCode);
      if (homeroute) {
        const user = {
          authenticated: true,
          success: true,
          up_domain: "up",
          insights_completed: true,
          user_client_id: Number,
          user_id: payload.accessCode,
          user_role: "cl",
          user_token: payload.accessCode,
          username: payload.accessCode,
          v3_ready: true
        }
        context.commit("setUser", user);
        context.dispatch("getClientBranding", payload.accessCode);
        payload.router.push(homeroute);
      }else {
        await context.commit("setWarning", 'Sorry that access code is not recognised');
      }
    },
    async newCodeLogin(context, payload){
      console.log(payload);
      try {
        let res = await axios.post(
          config.api_env + "/application/api/u/user/access-code-signup",
          payload.payload,
          config.options
        );
        if (res.data.success === true) {
          context.commit("setUser", res.data);
          context.commit("setLanguage", res.data.lang);
          //check if user is on v3 portal - if yes continue - if find their organisation
          if (res.data.v3_ready) {
            //if the subdomain is laya wellbeing don't get the clients branding
            if(context.state.subdomain !== 'laya-wellbeing') {
              context.dispatch("getClientBranding", res.data.user_token);
              context.dispatch("getClientInsights", res.data.user_token);
            }
            const homeroute = await context.dispatch(
              "getNav",
              res.data.user_token
            );
            context.state.previousRoute ? payload.router.push(context.state.previousRoute.path) : homeroute ? payload.router.push(homeroute) : payload.router.push("/")
            return true;
          } else return false;
        } else {
          await context.commit("setWarning", res.data.msg);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    async getNav(context, token) {
      const payload = {
        user_id: token,
        platform: 'web'
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/settings/get-nav",
        payload,
        config.options
      );
      if (res.data.success) {
        /* commented out for PMI requirments. Will remove fully when Steph is back to test properly
        //nav is hardcoded for laya wellbeing
        if(this.getters.subdomain === 'laya-wellbeing'){
          const layaNav = [{id:0,"items":[{"id":5,"name":"DigitalClinics","alias":"Digital Clinics","link":"/digital-clinics"}]},{"id":2,"items":[{"id":5,"name":"wellbeing","alias":"eLearning","link":"/wellbeing"}]},{"id":3,"items":[]},{"id":4,"items":[]},{"id":5,"items":[]},{"id":6,"items":[]},{"id":7,"items":[]}];
          //check if the virtual dropdown is active for a user - if it is, push it to the nav object
          const virtual = res.data.nav.find(x => {
            return x.items.find(y => y.name.toLowerCase() === "virtual" || y.name.toLowerCase() === "wellbeing studio" ) ? true : false
          })
          if(virtual){
            layaNav.push(virtual)
          }
          context.commit("setNav", layaNav);
          context.commit("setHomeRoute", "/digital-clinics");
          return "/digital-clinics";
        }else if(res.data.nav) {
         */
        if(res.data.nav){
          context.commit("setNav", res.data.nav);
          return "/";
          //Home page is the first top level page in nav
          // const homeLink = Object.values(res.data.nav).find(
          //     x => x.items.length === 1
          // );
          // if (homeLink) {
          //   context.commit("setHomeRoute", homeLink.items[0].link);
          //   return homeLink.items[0].link;
          // } else return "/";
        }
      }else return 0;
    },
    async loginAs(context, user) {
      context.commit("setUser", user.user_info);
      await context.dispatch("getClientBranding", user.user_token);
      await context.dispatch("getClientInsights", user.user_token);
      const nav = await context.dispatch("getNav", user.user_token);
      if(nav){
        return nav
      } else {
        context.commit("setWarning", 'User not valid')
        return "/login"
      }
      //return "/";
    },
    async getClientBranding(context, token) {
      let payload = {
        user_id: token
      };
      try {
        let clientOptions = await axios.post(
          config.api_env +
            "/application/api/customisations/get-client-branding",
          payload,
          config.options
        );
        if (clientOptions.data.success) {
          let client = clientOptions.data
          if(context.getters.hardcoded && context.getters.hardcoded.skin){
            client.skin = context.getters.hardcoded.skin
          }
          context.commit("setClientBranding", client);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    async getClientInsights(context, token) {
      let payload = {
        user_id: token
      };
      try {
        let clientInsights = await axios.post(
          config.api_env + "/application/api-hc/completed-insights",
          payload,
          config.options
        );
        context.commit("setUserInsightsStatus", clientInsights.data.completed);
      } catch (e) {
        //console.log(e);
      }
    },
    acceptWarning(context) {
      context.commit("acceptWarning");
    },
    async logout(context, previousRoute = null) {
      let payload = {
        "user_id":   context.state.user.user_token
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/user/logout",
        payload,
        config.options
      );
      if(context.getters.skin === 13){
        window.Intercom('shutdown')
      }
      if(previousRoute){
        context.commit("setPreviousRoute", previousRoute)
      }
      context.commit("setUser", defaultUser);
    },
    viewEvent(context, event) {
      context.commit("viewEvent", event);
    },
    setPodcastQueue(context, podcastQueue) {
      context.commit("setPodcastQueue", podcastQueue.queue);
      context.commit("setPodcastQueuePosition", podcastQueue.position);
    },
    setUserTermsAgreementTrue(context){
      context.commit("setUserTermsAgreementTrue");
    },
    setUserPPAgreementTrue(context){
      context.commit("setUserPPAgreementTrue");
    },
    setCoach(context, coach){
      context.commit("setCoach", coach);
    },
    setUserCookiesAgreementTrue(context){
      context.commit("setUserCookiesAgreementTrue");
    },
    setSamlTrue(context){
      context.commit("setSamlTrue");
    },
    async selectLanguage(context, language){
      context.commit('setLanguage', language)
      if(context.state.user.authenticated) {
        const payload = {
          user_id: context.getters.user_id,
          lang: language
        }
        await axios.post(config.api_env + '/application/api/u/settings/set-user-language', payload, config.options)
        let nav = await context.dispatch('getNav', context.getters.user_id)
        location.reload()
      }
    },
    clearNav(context){
      context.commit('setNav', [])
    }
  },
  plugins: [
    createPersistedState({
      paths: [
        "user",
        "client",
        "isIE",
        "isSaml",
        "home_page",
        "cutOffCounter",
        "nav",
        "homeRoute",
        "subdomain",
        "eventsOnly",
        "accessCode",
        "lang",
          "pageTitle"
      ]
    })
  ],
  modules: {}
});
